/**
 * SuggestionsAlertCard
 *
 * A clickable card displayed on the Details tab when checklist
 * match suggestions are available. Navigates to the Suggestions tab.
 */

import { Sparkles, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

interface SuggestionsAlertCardProps {
  count: number;
  onViewSuggestions: () => void;
}

export function SuggestionsAlertCard({
  count,
  onViewSuggestions,
}: SuggestionsAlertCardProps) {
  const { t } = useTranslation("documents");

  if (count === 0) return null;

  return (
    <button
      type="button"
      onClick={onViewSuggestions}
      className="w-full flex items-center gap-3 rounded-xl border border-amber-500/20 bg-linear-to-r from-amber-500/8 to-transparent px-4 py-3 hover:from-amber-500/12 transition-colors group cursor-pointer"
    >
      <div className="h-8 w-8 rounded-lg bg-amber-500/15 flex items-center justify-center shrink-0">
        <Sparkles size={16} className="text-amber-400" />
      </div>
      <div className="flex-1 text-left min-w-0">
        <p className="text-[13px] text-primary font-medium">
          {t("suggestionsAlertCard.matchesFound", { count })}
        </p>
        <p className="text-[11px] text-muted">
          {t("suggestionsAlertCard.reviewMatches")}
        </p>
      </div>
      <ChevronRight
        size={14}
        className="text-muted group-hover:text-secondary transition-colors shrink-0"
      />
    </button>
  );
}
